<template>
  <div class="agreement">
    <h2 class="center">
      <strong>法律声明及隐私政策</strong>
    </h2>
    <p class="sp_rf">最近更新日期：2020年04月09日</p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        复星高照（定义见《用户服务协议》，以下称“复星高照”或“我们”）非常重视用
        户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的
        相关信息。我们希望通过《法律声明及隐私政策》（“本隐私政策”）向您说明我们在您
        使用我们的产品与/或服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您
        提供的访问、更新、删除和保护这些信息的方式。
      </strong>
    </p>
    <p class="sp_cl">
      本隐私政策与您所使用的复星高照服务以及该服务所包括的各种业务功能（以下统称
      “我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确
      认您已经充分理解本隐私政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为
      适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说
      明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（
      <span
        class="sp_underLine"
      >
        我们会以在平台公告、
        短信推送、电子邮件或其他方式
      </span>及时提示您更新的情况）继续使用我们的产品与/或服务，
      即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、
      保存和共享您的相关信息。
    </p>
    <p class="sp_cl">
      为了让您可以正常使用复星高照服务，我们需要履行反洗钱职责、采取风险防范措施。
      收集、存储、使用、共享您的信息，是出于遵守国家法律法规的规定、向您提供服务及提升
      服务质量的需要（如支持我们开发新产品或完善已有产品功能，为您提供和推荐更为优质或
      适合的服务）。若您向我们提供了本隐私政策中列明的信息，您可享受更优质、更便捷的服
      务，让我们更好地保护您的账户及资金安全，避免我们无法及时与您取得联系而产生对您不
      利的影响。
    </p>
    <p class="sp_cl">
      <strong>第一部分 法律声明</strong>
    </p>
    <p class="sp_cl">
      除非复星高照另行声明，复星高照内的所有产品、技术、软件、程序、数据及其他信息
      （包括文字、图标、图片、照片、音频、视频、图表、色彩组合、版面设计等）的所有权利
      （包括版权、商标权、专利权、商业秘密及其他相关权利）均归复星高照或复星高照服务提
      供者及/或其关联公司所有。未经复星高照或复星高照服务提供者及/或其关联公司许可，任
      何人不得以包括通过机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下
      载等方式擅自使用复星高照内的任何内容。
    </p>
    <p class="sp_cl">
      复星高照转载的作品（包括论坛内容）出于传递更多信息之目的，并不意味我们赞同其
      观点或已经证实其内容的真实性。
    </p>
    <p class="sp_cl">
      我们尊重知识产权，反对并打击侵犯知识产权的行为。知识产权权利人若认为复星高照
      内容（包括但不限于复星高照用户发布的商品信息）侵犯其合法权益的，可以向我们进行投
      诉，我们将在收到知识产权权利人合格通知后依据相应的法律法规以及平台规则及时处理。
    </p>
    <p class="sp_cl">
      <strong>第二部分 隐私权政策</strong>
    </p>
    <p class="sp_cl">一、我们如何收集和使用您的信息</p>
    <p class="sp_cl">
      个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然
      人身份或者反映特定自然人活动情况的各种信息。
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        个人敏感信息指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人
        名誉、身心健康受到损害或歧视性待遇等的个人信息，本隐私政策中涉及的个人敏感信息
        包括身份证件号码、手机号码行踪轨迹、交易信息等。
      </strong>
    </p>
    <p class="sp_cl">我们会出于本隐私政策所述的以下目的，收集和使用您的个人信息：</p>
    <p class="sp_cl">（一）用户注册</p>
    <p class="sp_cl">您首先需要注册一个复星高照账户成为复星高照用户。</p>
    <p class="sp_cl">
      1、在您注册复星高照账户或使用复星高照服务时，您需要提供您的手机号码。如您不
      提供上述信息，将无法注册账户或无法为您提供服务。同时为了验证该类信息的准确性和完
      整性，您同意我们将您提供的信息提供给其他合法保存您信息的机构（如政府机关、事业
      单位、复星高照关联公司和合作伙伴等）进行验证核对；我们会确保该等验证机构提供的信
      息来源合法性以便不会侵犯您的利益。
    </p>
    <p class="sp_cl">
      2、若您为个人用户，在发生反洗钱相关法律法规规定及监管规定的特定情形时，需要
      您提供有效身份证件的彩色扫描件以供我们核对并留存；如您不提供，我们可能无法为您注
      册账户或提供其他服务。
    </p>
    <p class="sp_cl">
      3、您可以修改补充您的昵称、性别、职业以及您的实名验证等相关信息，这些信息均
      属于您的“账户信息”。您补充的账户信息将有助于我们为您提供个性化的商品和服务。
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        在注册会员过程中，如果您提供以下额外信息补全个人资料，将有助于我们给您提供
        如会员生日特权等更个性化的会员服务：您的真实姓名、身份证号码、性别、出生年月日、
        城市、职业、个性签名、您本人的真实头像。但如果您不提供这些信息，将会影响到您使
        用个性化的会员服务，但不会影响使用复星高照产品或服务的基本浏览、搜索、购买功能。
      </strong>
    </p>
    <p class="sp_cl">（二）为您展示和推送商品或服务</p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        为改善我们的产品或服务、向您提供个性化的信息搜索及交易服务，我们会根据您的
        浏览及搜索记录、设备信息、位置信息，提取您的浏览、搜索偏好、行为习惯、位置信息
        等特征，基于特征标签进行间接人群画像并展示、推送信息。
      </strong>
    </p>
    <p class="sp_cl">（三）支付</p>
    <p class="sp_cl">
      在您对商品或服务下单后，您可以选择与复星高照合作的第三方支付机构所提供的支付
      服务。在使用支付服务前，您需要提供您的
      <strong class="sp_underLine">
        姓名、身份证号码、银行卡号、手机号、身份
        证正反面照片
      </strong>，同时我们需要将您的订单号、交易金额等交易信息与这些支付机构共享以实
      现其确认您的支付指令并完成支付。
    </p>
    <p class="sp_cl">（四）投诉处理</p>
    <p class="sp_cl">
      为了保护您及他人的合法权益，维护绿色购物环境，如您被他人投诉或投诉他人，我们
      会将您的姓名及身份证号码、投诉相关内容提供给消费者权益保护部门及监管机关，以便及
      时解决投诉纠纷；但法律法规明确禁止提供的除外。
    </p>
    <p class="sp_cl">（五）风险防范</p>
    <p class="sp_cl">
      为了防止您的账户、资金、个人信息被不法分子获取，我们会收集关于您使用的服务以
      及使用方式的信息并将这些信息进行关联，这些信息包括：
    </p>
    <p class="sp_cl">
      1、设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使
      用的设备相关信息（例如设备型号、操作系统版本、设备设置、唯一设备标识符等软硬件特
      征信息）、设备所在位置相关信息（例如IP地址、GPS位置以及能够提供相关信息的Wi-Fi
      接入点、蓝牙和基站等传感器信息）。
    </p>
    <p class="sp_cl">
      2、日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您
      对我们服务的详细使用情况，作为有关网络日志保存。例如您的搜索查询内容、IP地址、
      浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录等。
    </p>
    <p class="sp_cl">
      请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果我们将
      这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，
      则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定
      外，我们会将该类个人信息做匿名化、去标识化处理。
    </p>
    <p class="sp_cl">（六）为了提供服务状态通知及查询服务</p>
    <p class="sp_cl">
      为了遵守法律法规及监管规定，也为了便于您查询交易状态或历史记录，我们会将您使
      用复星高照服务时的
      <strong
        class="sp_underLine"
      >身份信息、交易信息、行为信息</strong>进行存档，并严格按照法律法规的规定
      对这些信息进行妥善保管。为了使您知晓使用复星高照服务的状态，我们会根据这些信息向
      您发送服务状态通知。
    </p>
    <p class="sp_cl">（七）向您提供商品或服务</p>
    <p class="sp_cl">
      1、您向我们提供的信息
      为便于向您交付商品或服务，您需提供收货人姓名、收货地址、邮政编码、收货人联系
      电话。如果我们或商家委托第三方向您交付时，我们会将将上述信息共享给第三方。如果您
      拒绝提供此类信息，商家将无法完成相关交付服务。
    </p>
    <p class="sp_cl">2、我们在您使用服务过程中收集的信息</p>
    <p class="sp_cl">
      为提升您的服务体验及改进服务质量，或为防范风险，或者为您推荐更优质或更适合的
      服务，我们会收集您使用复星高照服务时的
      <strong class="sp_underLine">
        搜索记录，收集您与我们联系时提供的信息，
        及您使用的服务类别和方式、使用服务时的操作信息以及有关您曾使用复星高照的信息；
        还会向复星高照关联公司和合作伙伴收集其合法留存的您的行为信息、交易信息
      </strong>。我们会
      对这些信息进行统计、分析，以为您提供更加准确、个性、流畅及便捷的服务，并会根据上
      述信息向您提供您可能感兴趣的广告。为了提升处理效率，降低处理成本，或提高处理准确
      性，我们可能会委托有能力的复星高照关联公司来为我们提供这方面服务，但我们会要求该
      公司遵守严格的保密义务及采取有效的保密措施，禁止其将这些信息用于未经您授权的用途。
    </p>
    <p class="sp_cl">3、系统权限的调用</p>
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="equipment" label="设备权限"></el-table-column>
      <el-table-column prop="business" label="对应的业务功能"></el-table-column>
      <el-table-column prop="aims" label="调用权限目的"></el-table-column>
      <el-table-column prop="time" label="询问时间"></el-table-column>
      <el-table-column prop="whether" label="用户可否关闭权限"></el-table-column>
    </el-table>
    <p class="sp_cl"></p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上
        述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些
        个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此
        前基于您的授权所进行的个人信息的处理。
      </strong>
    </p>
    <p class="sp_cl">
      为展示您账户的订单信息，我们会收集您在使用我们服务过程中产生的订单信息用于向
      您展示及便于您对订单进行管理。
    </p>
    <p class="sp_cl">
      当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等
      信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。
    </p>
    <p class="sp_cl">4、我们通过间接获得方式收集到的您的个人信息</p>
    <p class="sp_cl">
      为确认交易状态及为您提供售后与争议解决服务，我们会通过您基于交易所选择的交易
      对象、物流公司等收集与交易进度相关的您的交易、物流信息，或将您的交易信息共享给上
      述服务提供者。
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        当您通过我们产品或服务使用上述服务时，您授权我们根据实际业务及合作需要从我
        们关联公司处接收、汇总、分析我们确认其来源合法或您授权同意其向我们提供的您的个
        人信息或交易信息。
      </strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        如您拒绝提供上述信息或拒绝授权，可能无法使用我们关联公司的相应产品或服务，
        或者无法展示相关信息。
      </strong>
    </p>
    <p class="sp_cl">5、为您提供安全保障</p>
    <p class="sp_cl">
      为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或
      公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络
      攻击、网络侵入等安全风险，更准确地识别违反法律法规或复星高照相关协议规则的情况，
      <strong
        class="sp_underLine"
      >
        我们可能使用或整合您的会员信息、交易信息、设备信息、有关网络日志以及我们关联公
        司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身
        份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
      </strong>
    </p>
    <p class="sp_cl">6、其他用途</p>
    <p class="sp_cl">
      我们将信息用于本隐私政策未载明的其他用途，或者将基于特定目的收集而来的信息
      用于其他目的时，会事先征求您的同意。
    </p>
    <p class="sp_cl">7、征得授权同意的例外</p>
    <p class="sp_cl">根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</p>
    <p class="sp_cl">（1）与国家安全、国防安全有关的；</p>
    <p class="sp_cl">（2）与公共安全、公共卫生、重大公共利益有关的；</p>
    <p class="sp_cl">（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p class="sp_cl">
      （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您
      本人同意的；
    </p>
    <p class="sp_cl">（5）所收集的个人信息是您自行向社会公众公开的；</p>
    <p class="sp_cl">
      （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等
      渠道；
    </p>
    <p class="sp_cl">（7）根据您的要求签订合同所必需的；</p>
    <p class="sp_cl">
      （8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或
      服务的故障；
    </p>
    <p class="sp_cl">（9）为合法的新闻报道所必需的；</p>
    <p class="sp_cl">
      （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或
      描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
    </p>
    <p class="sp_cl">（11）法律法规规定的其他情形。</p>
    <p class="sp_cl">二、网站信标和像素标签</p>
    <p class="sp_cl">
      我们会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子
      邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，
      帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种
      嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮
      件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单
      中退订。
    </p>
    <p class="sp_cl">三、我们如何存储和保护个人信息</p>
    <p class="sp_cl">
      （一）我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境
      内。我们仅在本隐私政策所述目的所必需期间和法律法规要求的时限内保留您的个人信息。
    </p>
    <p class="sp_cl">
      （二）我们承诺我们将使信息安全保护达到合理的安全水平。为保障您的信息安全，
      我们致力于使用各种安全技术及配套的管理体系来防止您的信息被泄露、毁损或者丢失，如
      通过网络安全层软件（SSL）进行加密传输、信息加密存储、严格限制数据中心的访问、使
      用专用网络通道及网络代理。同时我们建立了相关内控制度，对可能接触到您的信息的工作
      人员采取最小够用授权原则。如由于我们的失误导致您的信息被泄露，因此造成您的直接经济损失，我们将向您承担赔偿责任。
    </p>
    <p class="sp_cl">
      （三）
      <strong class="sp_underLine">
        请您理解，由于技术水平限制及可能存在的各种恶意手段，有可能因我们可控
        范围外的因素而出现问题。
      </strong>在不幸发生个人信息安全事件后，我们将按照法律法规的要求，
      及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您
      可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信
      函、电话或推送通知方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的
      方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。如我们未履行上述义务导致您损失的，我们将赔偿您因此遭受的直接经济损。
    </p>
    <p class="sp_cl">
      （四）如您通过我们的网站或客户端，使用了由第三方而非复星高照提供的服务时，
      我们无法保证这些第三方主体会按照我们的要求采取保护措施，为尽力确保您的账号安全，
      使您获得更安全的访问体验，我们可能会使用专用的网络协议及代理技术（称为“专用网络
      通道”、“网络代理”）。使用专用网络通道，可以帮助您识别到我们已知的高风险站点，
      减少由此引起的钓鱼、账号泄露等风险，同时更有利于保障您和第三方的共同权益，阻止不
      法分子篡改您和您希望访问的第三方之间正常服务内容，例如不安全路由器、非法基站等引
      起的广告注入、非法内容篡改等。在此过程中，我们也可能会获得和保存关于您计算机的相
      关信息，比如IP地址、硬件ID。
    </p>
    <p class="sp_cl">
      （五）如我们停止运营，我们将及时停止继续收集您个人信息的活动，将停止运营的
      通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。
    </p>
    <p class="sp_cl">四、我们如何共享、转让、公开披露您的个人信息</p>
    <p class="sp_cl">（一）共享</p>
    <p class="sp_cl">
      我们不会与复星高照服务提供者以外的公司、组织和个人共享您的个人信息，但以下情
      况除外：
    </p>
    <p class="sp_cl">
      1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个
      人信息。
    </p>
    <p class="sp_cl">
      2、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行
      政、司法机关依法提出的要求，对外共享您的个人信息。
    </p>
    <p class="sp_cl">
      3、与关联公司间共享：
      <strong class="sp_underLine">
        为便于我们基于关联账号共同向您提供服务，推荐您可能感兴
        趣的信息或保护复星高照关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人
        信息可能会与我们的关联公司共享。
      </strong>我们只会共享必要的个人信息，如果我们共享您的个
      人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。
    </p>
    <p class="sp_cl">
      4、与授权合作伙伴共享：
      <strong class="sp_underLine">
        仅为实现本隐私权政策中声明的目的，我们的某些服务将由
        我们和授权合作伙伴共同提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更
        好的客户服务和用户体验。
      </strong>例如，在您通过复星高照购物时，我们必须与为您提供商品/服
      务的商家、物流服务提供商共享您的个人信息才能安排送货，或者安排合作伙伴提供服务。
      我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供
      服务所必要的个人信息。
      <strong
        class="sp_underLine"
      >
        我们的合作伙伴无权将共享的个人信息用于与产品或服务无关的
        其他用途。
      </strong>
    </p>
    <p class="sp_cl">目前，我们的授权合作伙伴包括以下类型：</p>
    <p class="sp_cl">
      （1）广告、分析服务类的授权合作伙伴。我们会向这些合作伙伴提供有关其广告覆盖
      面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行汇总，以便它
      不会识别您个人。
    </p>
    <p class="sp_cl">
      （2）供应商、服务提供商、商家和其他合作伙伴。我们将信息发送给支持我们业务的
      供应商、服务提供商、商家和其他合作伙伴，这些支持包括提供商品/服务、技术基础设施
      服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进
      行学术研究和调查。
    </p>
    <p class="sp_cl">
      对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的数据保护协定，
      要求他们按照我们的说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信
      息。
    </p>
    <p class="sp_cl">（二）转让</p>
    <p class="sp_cl">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
    <p class="sp_cl">1、事先获得您明确的同意或授权；</p>
    <p class="sp_cl">
      2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进
      行提供；
    </p>
    <p class="sp_cl">
      3、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您
      个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织重新向您征
      求授权同意。
    </p>
    <p class="sp_cl">（三）公开披露</p>
    <p class="sp_cl">我们仅会在以下情况下，公开披露您的个人信息：</p>
    <p class="sp_cl">1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        2、如果我们确定您出现违反法律法规或严重违反复星高照相关协议规则的情况，或为
        保护复星高照及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规
        或复星高照相关协议规则征得您同意的情况下披露关于您的个人信息。
      </strong>
    </p>
    <p class="sp_cl">
      （四）共享、转让、公开披露个人信息时事先征得授权同意的例外
      以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
    </p>
    <p class="sp_cl">1、与国家安全、国防安全有关的；</p>
    <p class="sp_cl">2、与公共安全、公共卫生、重大公共利益有关的；</p>
    <p class="sp_cl">3、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p class="sp_cl">4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
    <p class="sp_cl">5、您自行向社会公众公开的个人信息；</p>
    <p class="sp_cl">
      6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠
      道。
    </p>
    <p class="sp_cl">
      根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并
      重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据
      的保存及处理将无需另行向您通知并征得您的同意。
    </p>
    <p class="sp_cl">五、您如何管理您的个人信息</p>
    <p class="sp_cl">您可以通过以下方式访问及管理您的个人信息：</p>
    <p class="sp_cl">
      （一）您可通过联系复星高照客服查阅或修改您的账户、个人信息。出于安全性和身份
      识别的考虑或根据法律法规的强制规定，您可能无法修改注册时提供的初始注册信息。
    </p>
    <p class="sp_cl">
      （二）您可通过联系复星高照客服注销您的复星高照账户。注销复星高照账户后，您该
      账户内的所有信息将被清空，我们将不会再收集、使用或共享与该账户相关的个人信息，
      <strong
        class="sp_underLine"
      >
        但
        之前的信息我们仍需按照监管要求的时间进行保存，且在该依法保存的时间内有权机关仍
        有权依法查询。
      </strong>
    </p>
    <p class="sp_cl">
      （三）如您发现我们采集、使用您个人信息的行为，违反了法律、行政法规规定或违反
      了与您的约定，您可联系我们，要求删除该违反行为下采集的您的个人信息。
    </p>
    <p class="sp_cl">（四）如您发现我们采集、储存的您的个人信息有错误的，您可以联系我们要求更正。</p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        （五）在响应您上述（三）、（四）项要求前，为保障安全，我们需要先验证您的身
        份和凭证资料，验证通过后将在三个工作日内处理完成；有特殊情形的，最长将在不超过
        三十天或法律法规规定期限内作出答复。如您不满意我们的答复，还可以向消费者权益保
        护部门投诉或向有管辖权的法院提起诉讼。
      </strong>
    </p>
    <p class="sp_cl">
      （六）尽管有上述约定，但按照法律法规要求，在以下情形下，我们可能无法响应您
      的请求：
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">1、与国家安全、国防安全有关的；</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">2、与公共安全、公共卫生、重大公共利益有关的；</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">3、与犯罪侦查、起诉和审判等有关的；</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">4、有充分证据表明您存在主观恶意或滥用权利的；</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">5、响应您的请求将导致其他个人、组织的合法权益受到严重损害的。</strong>
    </p>
    <p class="sp_cl">
      <strong class="sp_underLine">6、涉及商业秘密的</strong>
    </p>
    <p class="sp_cl">六、本隐私权政策如何更新</p>
    <p class="sp_cl">
      <strong class="sp_underLine">
        基于业务功能、使用规则、联络方式、保存地域变更或法律法规及监管要求，我们可
        能会适时对本隐私政策进行修订。由于复星高照的用户较多，如本隐私政策发生变更，我
        们将以在平台公告、短信推送、电子邮件或其他方式来通知您。若您在本隐私政策修订后
        继续使用复星高照服务，这表示您已充分阅读、理解并接受修订后的本隐私政策并愿意受
        修订后的本隐私政策约束。
      </strong>
    </p>
    <p class="sp_cl">七.联系方式</p>
    <p class="sp_cl">如果您对本协议有任何问题，请通过以下途径联系复星高照，平台会尽最大努力在合理时间内对您的问题进行回复和处理：</p>
    <p class="sp_cl">复星高照公司全称：上海复爱信息科技有限公司</p>
    <p class="sp_cl">注册地址：上海市黄浦区复兴东路2号1006室</p>
    <p class="sp_cl">常用办公地址：上海市黄浦区复兴东路2号1006室</p>
    <p class="sp_cl">信息保护负责人联系方式： 4000128128  （工作日 9:00-18:00 周末 9:00-17:00）</p>
  </div>
</template>
<script>
export default {
  name: "privacyPolicy",
  data() {
    return {
      tableData: [
        {
          equipment: "位置",
          business: "全部功能",
          aims: "基于位置信息的个性化推荐功能",
          time: "启动APP",
          whether: "可以"
        },
        {
          equipment: "照片",
          business: "扫一扫、个人中心",
          aims: "读取相册实现照片或视频上传、扫码以及将照片或视频保存至手机",
          time: "上传照片或视频保存照片或视频到手机",
          whether: "可以"
        },
        {
          equipment: "相机",
          business: "扫一扫、个人中心",
          aims: "视频拍摄、拍照、扫码等功能",
          time: "拍摄、拍照",
          whether: "可以"
        },
        {
          equipment: "拨打电话",
          business: "客服服务",
          aims: "拨打电话前询问",
          time: "启动APP",
          whether: "可以"
        },
        {
          equipment: "开启移动数据",
          business: "全部功能",
          aims: "连接网络",
          time: "程序启动时检测网络状态",
          whether: "可以"
        },
        {
          equipment: "开启WLAN",
          business: "全部功能",
          aims: "连接网络",
          time: "启动程序启动时检测网络状态",
          whether: "可以"
        }
      ]
    };
  },
  methods: {}
};
</script>
<style scoped lang="less">
.agreement {
  text-align: left;
  padding: 20px;
  .sp_cl {
    text-indent: 2em;
  }
  .sp_rf {
    text-align: right;
  }
  .sp_underLine {
    text-decoration: underline;
  }
  .center {
    text-align: center;
  }
}
</style>
